import React, { FC } from 'react';
import FormContainer, { PreviousPage } from '../Shared/FormContainer/FormContainer';
import { FORM_MULTI_TEXT_COMPONENT_TYPES, FORM_MULTI_TEXT_LAYOUT } from './types';
import { FormMultiTextContainer, FormMultiTextInput, FormMultiTextWrapper } from './styled';
import { ErrorMessage } from '../Shared/Shared';
import { UseFormReturn } from 'react-hook-form';
import { RequireAtLeastOne } from '../../types';

interface FormMultiTextProps {
  type?: keyof typeof FORM_MULTI_TEXT_COMPONENT_TYPES;
  formOptions: UseFormReturn;
  onSubmit: (data: Record<string, string>) => void;
  title?: string;
  placeholder?: string;
  loading?: boolean;
  error?: string;
  previousPage?: PreviousPage;
  defaultValue?: { [key: string]: string };
  componentItems?: {
    title: string;
    registerAs: string[];
    requiredMessage: string;
    pattern: RegExp[];
    patternMessage: string;
    placeholder: string[];
    optionalFields?: string[];
    layout: FORM_MULTI_TEXT_LAYOUT;
    widths: (number | undefined)[];
    enabledFields: string[];
    defaultValues: string[];
  };
}

const FormMultiText: FC<RequireAtLeastOne<FormMultiTextProps, 'type' | 'componentItems'>> = ({
  type,
  formOptions,
  onSubmit,
  title,
  placeholder,
  loading,
  error,
  previousPage,
  defaultValue,
  componentItems
}) => {
  const { register, handleSubmit, formState } = formOptions;
  const {
    title: defaultTitle,
    registerAs,
    requiredMessage,
    pattern,
    patternMessage,
    placeholder: defaultPlaceholder,
    optionalFields,
    layout,
    widths,
    enabledFields,
    defaultValues
  } = componentItems || FORM_MULTI_TEXT_COMPONENT_TYPES[type!];
  const hasErrors = !!Object.values(formState.errors).length;

  return (
    <FormMultiTextWrapper>
      <FormContainer title={title || defaultTitle} loading={loading} previousPage={previousPage} error={hasErrors} onSubmit={handleSubmit(onSubmit)}>
        <>
          <FormMultiTextContainer layout={layout}>
            {registerAs.map((registerItem, index) => {
              const isOptional = optionalFields?.includes(registerItem);
              return (
                <FormMultiTextInput
                  key={registerItem}
                  width={widths[index]}
                  {...register(registerItem, {
                    required: isOptional ? false : requiredMessage || 'This field is required',
                    pattern: {
                      value: pattern[index] || /.*/,
                      message: patternMessage || 'Invalid input'
                    }
                  })}
                  placeholder={placeholder || defaultPlaceholder[index]}
                  autoFocus
                  error={!!error || !!formState.errors[registerItem]}
                  readOnly={!enabledFields.includes(registerItem)}
                />
              );
            })}
          </FormMultiTextContainer>
          {hasErrors && <ErrorMessage>{patternMessage}</ErrorMessage>}
        </>
      </FormContainer>
    </FormMultiTextWrapper>
  );
};
export default FormMultiText;
